import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import type { BooleanLabelProps as Props } from './types';

export const BooleanLabel = memo(({ className, value, yes, no }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('BooleanLabel', className)}
      color={value ? 'success' : 'error'}
      label={value ? yes || 'Yes' : no || 'No'}
    />
  );
});

BooleanLabel.displayName = 'BooleanLabel';
